import { Base } from './base';
import '@gnyio/interfaces';
import '../connection';
export class Uia {
    constructor(connection) {
        this.base = new Base(connection);
    }
    async getIssuers(limit, offset) {
        const params = {
            limit: limit,
            offset: offset,
        };
        const res = await this.base.get('/api/uia/issuers', params);
        const result = res.data;
        return result;
    }
    async isIssuer(address) {
        const res = await this.base.get(`/api/uia/isIssuer/${address}`);
        const result = res.data;
        return result;
    }
    async getIssuer(name) {
        const res = await this.base.get(`/api/uia/issuers/${name}`);
        const result = res.data;
        return result;
    }
    async getIssuerAssets(name, limit, offset) {
        const params = {
            limit: limit,
            offset: offset,
        };
        const res = await this.base.get(`/api/uia/issuers/${name}/assets`, params);
        const result = res.data;
        return result;
    }
    async getAssets(limit, offset) {
        const params = {
            limit: limit,
            offset: offset,
        };
        const res = await this.base.get('/api/uia/assets', params);
        const result = res.data;
        return result;
    }
    async getAsset(name) {
        const res = await this.base.get(`/api/uia/assets/${name}`);
        const result = res.data;
        return result;
    }
    async getBalances(address, limit, offset) {
        const params = {
            limit: limit,
            offset: offset,
        };
        const res = await this.base.get(`/api/uia/balances/${address}`, params);
        const result = res.data;
        return result;
    }
    async getBalance(address, currency) {
        const res = await this.base.get(`/api/uia/balances/${address}/${currency}`);
        const result = res.data;
        return result;
    }
    async getHolders(asset, limit = 100, offset = 0) {
        const res = await this.base.get(`/api/uia/holders/${asset}?limit=${limit}&offset=${offset}`);
        const result = res.data;
        return result;
    }
}
//# sourceMappingURL=uia.js.map